import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { SimulationFailure, SimulationRequest, SimulationSuccess } from './actions';
import { SimulationService } from './service';

@Injectable()
export class SimulationEffects {
  private readonly actions$ = inject(Actions);
  private readonly simulationService = inject(SimulationService);

  simulation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SimulationRequest),
      switchMap(({ parameters }) =>
        this.simulationService.simulation(parameters).pipe(
          map(data => SimulationSuccess({ data })),
          catchError(error => of(SimulationFailure({ error })))
        )
      )
    )
  );

}
